// TODO: [1] remove redundant store in separate PR (needs to be a breaking change)
const reducer = {};

export default (state = {}, action) => (
  action.type && reducer[action.type] ? reducer[action.type](state, action) : state
);
